import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import { OffersDatabackManagementPage } from './pages';
import { DataRewards } from './data-rewards.setup';

export const DataRewardsModule: ProductLinePermission = {
  id: DataRewards.id,
  title: 'PAGE.DATA_REWARDS.TITLE',
  path: DataRewards.path,
  pages: [OffersDatabackManagementPage],
  showInSidebar: true,
  iconClass: 'fal fa-funnel-dollar',
};
